import React, { Fragment } from "react";
// import { Transition } from "@headlessui/react";
import StepTitle from "./StepTitle";

const ModalContainer = ({
  isOpen,
  formStep,
  maxFormStep,
  children,
  onClick,
  stepTitleContent,
  signUpSuccessful,
}) => {
  return (
    <Fragment>
      <div className="flex flex-col justify-between pt-12 pb-20 md:py-10 px-10 md:mx-auto w-screen h-screen md:h-auto md:max-w-5xl bg-white relative md:top-1/4 overflow-y-auto md:overflow-y-hidden overflow-x-hidden z-20">
        <div className="divide-y-2 divide-coolGray-200 pb-5 z-10 h-full">
          <div className="flex justify-between">
            <div className="text-left min-w-max pt-2">
              <div className="tracking-wide text-md font-bold text-coolGray-500 mb- leading-tight">
                Step {formStep} of {maxFormStep}
              </div>
              <StepTitle
                formStep={formStep}
                stepTitleContent={stepTitleContent}
                signUpSuccessful={signUpSuccessful}
              />
            </div>
            <div
              className="justify-self-start self-start group flex justify-between cursor-pointer"
              onClick={onClick}
            >
              <div className="text-dms-primary mr-1">cancel</div>
              <svg
                fill="none"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="text-dms-primary"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>

          {children}
        </div>
      </div>
    </Fragment>
  );
};

export default ModalContainer;
